import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
  dateRoot: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  countRoot: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  infoRoot: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  logEntry: {
    display: 'flex',
    gap: theme.spacing(2),
    width: 'fit-content',
    padding: theme.spacing(0, 0.5),
    alignItems: 'center',
  },
  levelInfo: {
    color: 'black',
  },
  levelWarn: {
    backgroundColor: '#8f7400',
    color: '#ffffff',
  },
  levelError: {
    backgroundColor: '#730000',
    color: '#ffffff',
  },
  paper: {
    flip: false,
    position: 'relative',
    width: `calc(100dvw - ${theme.spacing(2)}px)`,
    height: `calc(100dvh - 48px - ${theme.spacing(3)}px)`,
    padding: 8,
    backgroundColor: '#fff',
  },
  divscroll: {
    marginTop: '1rem',
    overflowX: 'scroll',
  },
  title: {
    borderRadius: '4px 4px 0 0',
    background: 'silver',
    fontWeight: 600,
    padding: '0.25rem 0.5rem',
    marginBottom: '1.25rem',
    margin: -8,
  },
}))
